export const CONTACT = {
  email: "makargafrancoisgautier@gmail.com",
  phoneDisplay: "+237 678 406 408",
  phoneRaw: "+237678406408",
  whatsapp: "237678406408",
  tiktok: "https://www.tiktok.com/@porte.de.lumire",
  facebookHub: "https://linktr.ee/makargafrancoisgautier6",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const WA_DEFAULT = waLink(
  "Bonjour François, je souhaite prendre contact avec Porte de Lumière. Merci !"
);
export const WA_SERVICES = waLink(
  "Bonjour François, je souhaite des informations sur vos accompagnements. Merci !"
);

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a25e8598-e574-427e-ae43-205584b7bcf1/images/a49b168abb0d29ef2048a8fe31ac0cd36a177c8a9e6fadf3cc6f865693ebbd3e.jpeg",
  clouds: "https://static.prod-images.emergentagent.com/jobs/a25e8598-e574-427e-ae43-205584b7bcf1/images/cb2892fde5df109f38006be4ecd192d771017a06ee23162caff13a61b966e9e8.jpeg",
  portrait:
    "https://static.prod-images.emergentagent.com/jobs/a25e8598-e574-427e-ae43-205584b7bcf1/images/86e1b55a9130c5dda55098a4405bf53c3fc34b3d23cef8208ca2579330b08b18.jpeg",
  veil: "https://static.prod-images.emergentagent.com/jobs/a25e8598-e574-427e-ae43-205584b7bcf1/images/bc8d79dd877886181159865a7939d96c02b7044f3bad24ec4a705ddaa844df0f.jpeg",
  badge: "https://static.prod-images.emergentagent.com/jobs/a25e8598-e574-427e-ae43-205584b7bcf1/images/1b3e2cbc4fe2c1c290dc271096d6c0d88f00d9cadb200d305da88c65967a8a0d.jpeg",
};

export const TESTIMONIALS = [
  {
    author: "A. M.",
    quote: "J'ai enfin compris d'où venaient certains schémas qui se répétaient dans ma famille. Merci pour cette écoute et cette douceur.",
  },
  {
    author: "S. K.",
    quote: "Un accompagnement bienveillant, dans un cadre de confiance et de confidentialité. Je me sens plus légère, plus alignée.",
  },
  {
    author: "J. D.",
    quote: "Le programme de six mois m'a permis d'explorer mon histoire familiale en profondeur, à mon rythme. Une vraie rencontre avec moi-même.",
  },
];

export const OFFERS = [
  {
    id: "analyse-informationnelle",
    title: "Analyse informationnelle",
    price: "19 000 FCFA",
    priceAlt: "≈ 29 € / 32 $",
    tagline: "Une séance d'exploration",
    description:
      "Une séance d'exploration permettant d'identifier et d'examiner les informations et les schémas que vous souhaitez travailler dans le cadre de votre démarche personnelle.",
    points: [
      "Identifier les informations et schémas personnels",
      "Examiner ce que vous souhaitez travailler",
      "Séance d'exploration personnalisée",
    ],
  },
  {
    id: "harmonisation-informationnelle",
    title: "Harmonisation informationnelle",
    price: "39 000 FCFA",
    priceAlt: "≈ 59 € / 65 $",
    tagline: "Un accompagnement individuel",
    description:
      "Un accompagnement individuel orienté vers une démarche d'harmonisation et de rééquilibrage selon l'approche informationnelle proposée par Porte de Lumière.",
    points: [
      "Harmonisation et rééquilibrage",
      "Approche informationnelle de Porte de Lumière",
      "Accompagnement individuel dédié",
    ],
  },
  {
    id: "programme-transgenerationnel-3-mois",
    title: "Accompagnement holistique transgénérationnel & vies passées",
    price: "150 000 FCFA",
    priceAlt: "≈ 229 € / 248 $",
    tagline: "Programme de 3 mois",
    description:
      "Un accompagnement personnalisé sur trois mois pour explorer votre histoire familiale, vos schémas transgénérationnels et, dans le cadre de votre démarche spirituelle, la thématique des vies passées. Le parcours est construit progressivement, selon votre situation et vos objectifs.",
    points: [
      "Exploration de votre histoire familiale",
      "Schémas transgénérationnels",
      "Thématique des vies passées (démarche spirituelle)",
      "Parcours progressif selon vos objectifs",
    ],
    duration: "Durée : 3 mois",
  },
  {
    id: "programme-transgenerationnel-6-mois",
    title: "Accompagnement holistique transgénérationnel & vies passées",
    price: "250 000 FCFA",
    priceAlt: "≈ 381 € / 412 $",
    tagline: "Programme de 6 mois",
    description:
      "Un accompagnement personnalisé sur six mois pour approfondir l'exploration de votre histoire familiale, de vos schémas transgénérationnels et de la thématique des vies passées. Un parcours complet, construit progressivement selon votre situation, vos questionnements et vos objectifs.",
    points: [
      "Exploration approfondie de votre histoire familiale",
      "Schémas transgénérationnels",
      "Thématique des vies passées (démarche spirituelle)",
      "Parcours progressif selon votre situation, vos questionnements et vos objectifs",
    ],
    duration: "Durée : 6 mois",
  },
];

export const DIMENSIONS = [
  {
    icon: "heart",
    title: "Dimension émotionnelle",
    text: "Écouter, mettre en mots et apaiser ce qui se vit en vous, dans un cadre de respect et de confidentialité.",
  },
  {
    icon: "sun",
    title: "Dimension énergétique",
    text: "Explorer et rééquilibrer les informations et schémas qui traversent votre vécu, selon l'approche informationnelle.",
  },
  {
    icon: "waypoints",
    title: "Dimension transgénérationnelle",
    text: "Remonter le fil de votre histoire familiale pour comprendre les schémas qui se transmettent.",
  },
  {
    icon: "moon",
    title: "Dimension spirituelle",
    text: "Ouvrir un espace d'exploration intérieure — y compris la thématique des vies passées — selon vos objectifs.",
  },
];

export const MARQUEE_ITEMS = [
  "Analyse informationnelle",
  "Harmonisation énergétique",
  "Psychogénéalogie",
  "Vies passées",
  "Nettoyage énergétique holistique",
  "Écoute & confidentialité",
  "Accompagnement personnalisé",
];

export const DISCLAIMER =
  "Les accompagnements proposés par Porte de Lumière relèvent d'une démarche de bien-être, de développement personnel et d'exploration spirituelle. Ils ne remplacent pas un diagnostic, un traitement ou un suivi médical ou psychologique lorsque celui-ci est nécessaire.";
